module.exports = __webpack_public_path__ + "img/003-powerpoint.393d0a25.svg";